import { Icon } from '@chakra-ui/react';
export const OwlIcon = (props) => (
  <Icon viewBox="0 0 512 512" {...props}>
    <g>
      <g>
        <path d="M150.892,255.999c-12.875,0-23.353,10.476-23.357,23.357c0.001,12.879,10.477,23.357,23.354,23.357h0.003 c12.879,0,23.357-10.478,23.357-23.357S163.771,255.999,150.892,255.999z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M361.107,255.999c-12.875,0-23.353,10.476-23.357,23.357c0.001,12.879,10.477,23.357,23.354,23.357h0.003 c12.879,0,23.357-10.478,23.357-23.357S373.986,255.999,361.107,255.999z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M512,54.629l-12.388-12.386c-16.543-16.544-38.539-25.654-61.935-25.654c-23.396,0-45.393,9.11-61.935,25.654 l-37.335,37.335c-26.096-10.804-53.757-16.277-82.407-16.277c-28.649,0-56.31,5.473-82.407,16.277l-37.335-37.336 c-16.543-16.544-38.54-25.654-61.935-25.654c-23.396,0-45.393,9.111-61.935,25.654L0,54.629l88.393,88.393 c-31.35,38.453-48.448,86.242-48.448,136.334c0,119.134,96.922,216.055,216.055,216.055s216.055-96.921,216.055-216.055 c0-50.096-17.098-97.883-48.447-136.334L512,54.629z M256.001,98.338c18.979,0,37.434,2.86,55.123,8.523l-55.123,55.123 l-55.123-55.123C218.567,101.198,237.022,98.338,256.001,98.338z M51.654,56.734c6.987-3.345,14.693-5.109,22.669-5.109 c14.038,0,27.236,5.467,37.161,15.392l144.515,144.515L400.516,67.017c9.927-9.926,23.124-15.392,37.161-15.392 c7.977,0,15.682,1.765,22.671,5.109L256.001,261.082L51.654,56.734z M361.108,226.803c28.978,0,52.554,23.575,52.554,52.554 c0,28.979-23.576,52.554-52.554,52.554s-52.554-23.575-52.554-52.554c0-12.438,4.353-23.872,11.6-32.882l8.071-8.07 C337.236,231.155,348.671,226.803,361.108,226.803z M283.711,320.303l-27.71,27.71l-27.71-27.71 c4.584-8.631,7.769-18.108,9.246-28.137l18.464,18.464l18.464-18.464C275.942,302.195,279.127,311.673,283.711,320.303z  M203.445,279.357c0,28.979-23.576,52.554-52.554,52.554s-52.554-23.575-52.554-52.554c0-28.979,23.576-52.554,52.554-52.554 c12.438,0,23.872,4.353,32.882,11.602l8.071,8.07C199.093,255.484,203.445,266.919,203.445,279.357z M113.316,167.946 l24.768,24.767c-21.615,3.182-40.677,14.288-54.15,30.263C90.41,203.169,100.306,184.566,113.316,167.946z M256.001,460.376 c-80.101,0-148.207-52.303-171.988-124.547c16.08,19.013,40.088,31.118,66.88,31.118c20.82,0,39.956-7.315,55.003-19.492 l50.105,50.104l50.105-50.104c15.047,12.176,34.183,19.492,55.003,19.492c26.792,0,50.8-12.104,66.88-31.118 C404.207,408.073,336.102,460.376,256.001,460.376z M428.068,222.977c-13.473-15.975-32.536-27.082-54.15-30.264l24.767-24.768 C411.696,184.565,421.591,203.169,428.068,222.977z" />
      </g>
    </g>
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </Icon>
);
